<template>
	<div v-if="showReceipt" class="trans-receipt" ref="printableContent">
		<div class="receipt-content-container" >
			<div
				class="receipt-content"
				id="receipt"
				style="margin: auto;width: 330px !important;background-color: #fff;padding:5px;"
			>
				<div
					class="receipt-header"
					style=" border-bottom: 2px solid black; text-align:center;"
				>
					<h3>
						<img :src="logo" alt="logo" style="width: 150px;"/>
					</h3>
					<p>{{ receiptDetail.response.agent_location }}</p>
				</div>
				<div class="receipt-body">
					<div class="details">
						<div class="col">
							<div
								class="item-row mt-2"
								style="display: flex; justify-content: space-between;"
							>
								<p style="font-size: 13px;">MERCHANT NAME:</p>
								<p style="font-size: 13px;">{{ receiptDetail.merchantName }}</p>
							</div>
							<div
								class="item-row"
								style="display: flex; justify-content: space-between;"
							>
								<p style="line-height: 0.5; font-size: 13px;">TERMINAL ID:</p>
								<p style="line-height: 0.5; font-size: 13px;">{{ receiptDetail.terminalId }}</p>
							</div>
							<div class="item-row"
								style="display: flex; justify-content: space-between; "
							>
								<p style="font-size: 13px;">DATE:</p>
								<p style="font-size: 13px;">{{ receiptDetail.response.transaction_date }}</p>
							</div>
							<div class="item-row"
								style="display: flex; justify-content: space-between;"
							>
								<p style="line-height: 0.5; font-size: 13px;">TIME:</p>
								<p style="line-height: 0.5; font-size: 13px;">{{ receiptDetail.response.transaction_time }}</p>
							</div>
							<div class="item-row"
								style="display: flex; justify-content: space-between;"
							>
								<p style="font-size: 13px;">CARDHOLDER:</p>
								<p style="font-size: 13px;">{{ receiptDetail.response.card_holder_name }}</p>
							</div>
							<div class="item-row"
								style="display: flex; justify-content: space-between;"
							>
								<p style="line-height: 0.5; font-size: 13px;">CARD TYPE:</p>
								<p style="line-height: 0.5; font-size: 13px;">{{ receiptDetail.response.card_type }}</p>
							</div>
							<div class="item-row"
								style="display: flex; justify-content: space-between;"
							>
								<p style="font-size: 13px;">EXPIRY DATE:</p>
								<p style="font-size: 13px;">{{ receiptDetail.response.card_expiry_date }}</p>
							</div>
							<div class="item-row"
								style="display: flex; justify-content: space-between;"
							>
								<p style="line-height: 0.5; font-size: 13px;">CARD NO:</p>
								<p style="line-height: 0.5; font-size: 13px;">{{ receiptDetail.maskedPan }}</p>
							</div>
							<div class="item-row"
								style="display: flex; justify-content: space-between;"
							>
								<p style="font-size: 13px;">TRANS TYPE:</p>
								<p style="font-size: 13px;">{{ receiptDetail.product }}</p>
							</div>
						</div>
						<div>
							<p
								style="font-weight: bold; padding-top: 15px; font-size: 15px; text-align: center;"
							>
								{{ receiptDetail.response.response_message }}
							</p>
						</div>
						<div
							class="item-row amount-row"
							:style="`padding: 0px; font-weight: bolder; color: #000; display: flex; justify-content:space-between; border-top: 1px solid black; border-bottom: 1px solid black; align-items: center`"
						>
							<p style="padding-left:8px;">AMOUNT:</p>
							<p style="padding-right:8px;">N{{ withdrawalAmount }}</p>
						</div>
						<div class="col">
							<div class="item-row"
								style="display: flex; justify-content: space-between;"
							>
								<p style="font-size: 13px;">RESPONSE CODE:</p>
								<p style="font-size: 13px;">{{ receiptDetail.response.responseCode }}</p>
							</div>
							<div class="item-row"
								style="display: flex; justify-content: space-between;"
							>
								<p style="line-height: 0.5; font-size: 13px;">RRN:</p>
								<p style="line-height: 0.5; font-size: 13px;">{{ receiptDetail.response.rrn }}</p>
							</div>
							<div class="item-row"
								style="display: flex; justify-content: space-between;"
							>
								<p style="font-size: 13px;">STAN:</p>
								<p style="font-size: 13px;">{{ receiptDetail.stan }}</p>
							</div>
							<!-- <div
								class=""
								style="display:block;"
							>
								<p style="line-height: 0.5; font-size: 13px;">REF:</p>
								<p style="line-height: ; font-size: 13px;">{{ receiptDetail.reference }}</p>
							</div> -->
							<div class="item-row"
								style="display: flex; justify-content: space-between;"
							>
								<p style="line-height: 0.5; font-size: 13px;">TVR:</p>
								<p style="line-height: 0.5; font-size: 13px;"></p>
							</div>
							<div class="item-row"
								style="display: flex; justify-content: space-between;"
							>
								<p style="font-size: 13px;">TSI:</p>
								<p style="font-size: 13px;"></p>
							</div>
							<div class="item-row"
								style="display: flex; justify-content: space-between;"
							>
								<p style="line-height: 0.5; font-size: 13px;">CRIM:</p>
								<p style="line-height: 0.5; font-size: 13px;"></p>
							</div>
						</div>
					</div>
					<div class="receipt-footer" style="text-align: center;">
						<p>------------------------------------------</p>
						<p style="text-align: center; padding: 0 1px; line-height: 1; font-size: 13px;">
							Enjoy seamless transaction with PAYZEEP POS <br />
							PAYZEEP POS 1.0.5
						</p>
					</div>
				</div>
			</div>
			<div
				class="receipt-btns"
			style="display: flex; justify-content: center; gap: 30px; justify-content: center; margin-top: 10px;"
			>
				<button class="btn btn primary" @click="closeReceipt()">Close</button>
				<button class="btn btn-primary" @click="printReceipt()">Print</button>
			</div>
		</div>
	</div>
</template>

<script>
import logo from '@/assets/img/payzeep-logo.png';

export default {
	data() {
		return {
			logo: logo,
		};
	},
	props: {
		showReceipt: {
			type: Boolean,
			required: true,
		},
		receiptDetail: {
			type: Object,
			required: true,
		},
		closeReceipt: {
			type: Function,
			required: true,
		}
	},
	computed: {
		withdrawalAmount() {
			return (this.receiptDetail.amount / 100).toFixed(2);
		},
	},
	methods: {
		printReceipt() {
			const receiptContent = this.$refs.printableContent;
			const a = window.open('', '', 'height=500, width=500');
			a.document.write('<html>');
			a.document.write('<body >');
			a.document.write(receiptContent.innerHTML);
			a.document.write('</body></html>');
			a.document.close();
			a.print();
			a.addEventListener('afterprint', () => {
				a.close();
			});
		},
	},
};
</script>

<style scoped>
.trans-receipt {
	position: absolute;
	inset: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 999;
}
.receipt-content-container {
	padding: 70px;
	background-color: rgba(0, 0, 0, 0.5);
	width: 100%;
}
</style>
